(function () {
  var config = window.FirgelliEmbedAnalyticsConfig || {};
  var endpoint = config.endpoint || "";
  var queue = [];

  function cleanSlug(value) {
    var slug = String(value || "").toLowerCase();
    return /^[a-z0-9][a-z0-9-]{0,120}$/.test(slug) ? slug : "";
  }

  function cleanType(value) {
    var allowed = {
      "calculator": true,
      "animation-calculator": true,
      "standard-calculator": true,
      "animated-calculator-canvas": true,
      "animated-calculator-svg": true,
      "animated-diagram-only": true
    };
    return allowed[value] ? value : "standard-calculator";
  }

  function getDomainFromUrl(value) {
    if (!value) return "";
    try {
      return new URL(value).hostname.replace(/^www\./, "").toLowerCase();
    } catch (error) {
      return "";
    }
  }

  function getDeviceType() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    var ua = navigator.userAgent || "";
    if (/ipad|tablet|kindle|silk/i.test(ua)) return "tablet";
    if (/mobi|android|iphone|ipod/i.test(ua) || width < 640) return "mobile";
    return "desktop";
  }

  function isEmbedded() {
    try {
      return window.self !== window.top;
    } catch (error) {
      return true;
    }
  }

  function normalizeEventName(name) {
    var allowed = {
      embed_button_click: true,
      embed_modal_open: true,
      embed_code_copy: true,
      iframe_load: true,
      attribution_click: true,
      full_calculator_click: true
    };
    return allowed[name] ? name : "";
  }

  function send(payload) {
    if (!endpoint) return;

    var body = JSON.stringify(payload);

    if (navigator.sendBeacon) {
      var blob = new Blob([body], { type: "application/json" });
      if (navigator.sendBeacon(endpoint, blob)) return;
    }

    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: body,
      keepalive: true,
      credentials: "omit"
    }).catch(function () {});
  }

  function track(eventName, details) {
    var eventType = normalizeEventName(eventName);
    if (!eventType) return;

    var payload = {
      eventType: eventType,
      calculatorSlug: cleanSlug(details && details.calculatorSlug),
      calculatorType: cleanType(details && details.calculatorType),
      referringDomain: getDomainFromUrl(document.referrer),
      pageDomain: window.location.hostname.replace(/^www\./, "").toLowerCase(),
      deviceType: getDeviceType(),
      embedded: isEmbedded(),
      timestamp: new Date().toISOString()
    };

    if (details && details.height) payload.height = Number(details.height) || undefined;
    if (details && details.linkLabel) payload.linkLabel = String(details.linkLabel).slice(0, 40);

    if (!payload.calculatorSlug) return;

    queue.push(payload);
    if (queue.length > 20) queue.shift();
    send(payload);
  }

  window.FirgelliEmbedAnalytics = {
    track: track,
    recentEvents: function () {
      return queue.slice();
    }
  };
})();
